import React, { Component } from "react";
import { Link } from "react-router-dom";
import Session from "../../utility/session";
import { connect } from "react-redux";
import { logoutAction } from "../../Containers/Login/actions";
import history from "../../utility/history";
class SideMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this._clickHandle = this._clickHandle.bind(this);
  }
  componentDidMount() {
    window["init_sidebar"]();
  }

  _clickHandle(e) {
    e.preventDefault();
    Session.logout();
    history.push("/login");
    this.props.dispatch(logoutAction());

    // setTimeout(() => {
    //   history.push("/login");
    // }, 1000);
  }

  render() {
    return (
      <div id="sidebar-menu" className="main_menu_side hidden-print main_menu">
        <div className="menu_section">
          <ul className="nav side-menu">
            <li>
              <Link to="/email-verification">
                <i className="fa fa-bar-chart-o" /> Email Verification
                <span className="fa fa-chevron-right" />
              </Link>
            </li>
            <li>
              <Link to="/dashboard">
                <i className="fa fa-map-signs" /> Dashboard
                <span className="fa fa-chevron-right" />
              </Link>
            </li>
            <li>
              <Link to="/pricing">
                <i className="fa fa-credit-card" /> Pricing
                <span className="fa fa-chevron-right" />
              </Link>
            </li>
            <li>
              <Link to="/settings">
                <i className="fa fa-cogs" />Account Settings
                <span className="fa fa-chevron-right" />
              </Link>
            </li>
            <li>
              <Link to="/help">
                <i className="fa fa-book" />Help
                <span className="fa fa-chevron-right" />
              </Link>
            </li>
            <li>
              <Link to="" onClick={this._clickHandle}>
                <i className="fa fa-sign-out" />Logout
                <span className="fa fa-chevron-right" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default connect()(SideMenu);



// WEBPACK FOOTER //
// ./src/components/SideBar/SideMenu.js